export default "__VITE_ASSET__93e89bc2__"